import "@babel/polyfill";
import React from "react";
import { Provider } from "react-redux";
import styled, { ThemeProvider } from "styled-components";
import { BrowserRouter as Router } from "react-router-dom";
import closeIcon from "./assets/close-icon.svg";
import { CookiesProvider } from "react-cookie";
import store from "./store";
import theme from "./theme";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import Routes from "./routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DisplayByPermission from "./component/DisplayByPermission";
import { AIChatbot } from "./container/reusableComponent/AIChatbot";
import { getLocalstorage } from "./helper";

export default class App extends React.Component {
  constructor() {
    super();
    this.state = {
      installButton: false,
      groupCategory: localStorage.getItem("groupCategory") || null
    };
  }

  installPrompt = null;
  componentDidMount() {
    console.log("Listening for Install prompt");
    window.addEventListener("beforeinstallprompt", e => {
      // For older browsers
      e.preventDefault();
      console.log("Install Prompt fired");
      this.installPrompt = e;
      // See if the app is already installed, in that case, do nothing
      if (
        (window.matchMedia &&
          window.matchMedia("(display-mode: standalone)").matches) ||
        window.navigator.standalone === true
      ) {
        return false;
      }
      // Set the state variable to make button visible
      this.setState({
        installButton: true
      });
    });

    window.addEventListener("groupCategoryUpdated", this.handleUpdate);
  }
  handleUpdate = () => {
    const newCategory = localStorage.getItem("groupCategory");
    this.setState({ groupCategory: newCategory });
  };
  componentWillUnmount() {
    window.removeEventListener("groupCategoryUpdated", this.handleUpdate);
  }

  installApp = async () => {
    if (!this.installPrompt) return false;
    this.installPrompt.prompt();
    let outcome = await this.installPrompt.userChoice;
    if (outcome.outcome === "accepted") {
      console.log("App Installed");
      // Remove the event reference
      this.installPrompt = null;
      // Hide the button
      this.setState({
        installButton: false
      });
    } else {
      console.log("App not installed");
    }
  };

  closePromptBtn = () => {
    this.setState({ installButton: false });
  };

  render() {
    const user = this.state.groupCategory;
    const category = JSON.parse(user);

    return (
      <>
        <ToastContainer
          pauseOnHover={true}
          draggable={false}
          toastClassName={{ marginLeft: "12px" }}
          autoClose="4000"
        />
        <CookiesProvider>
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <Router>
                <Routes />
                <DisplayByPermission display={this.state.installButton}>
                  <React.Fragment>
                    <div className="pwa-btn">
                      <div className="pwa-text" onClick={this.installApp}>
                        Add PMG To Home Screen
                      </div>
                      <img
                        src={closeIcon}
                        alt="close"
                        onClick={this.closePromptBtn}
                        className="pwa-close"
                      />
                    </div>
                  </React.Fragment>
                </DisplayByPermission>
              </Router>
            </ThemeProvider>
          </Provider>
          {category === "PMG" && <AIChatbot />}
        </CookiesProvider>
      </>
    );
  }
}
